import {NextPage} from 'next';
import {withBasicDataServerSide} from 'core/next/controllers';
import {ProductReviewPage} from 'modules/products/pages/ProductReviewPage';
import {ProductPageProvider} from 'modules/product-card/providers';
import {productReviewsControllerByCode} from 'modules/products/controller';
import {ProductReviewPageProvider} from 'modules/products/providers/ProductReviewPageProvider';
import {usePDPReviewsViewGtag} from 'modules/product-card/analytics/gtag/hooks/useViewPDPGtag';
import {IBreadcrumb} from 'modules/seo/types';

interface IReviewPageProps {
    breadcrumbs: IBreadcrumb[];
}

const ProductReview: NextPage<{pageProps: IReviewPageProps}> = ({pageProps}) => {
    usePDPReviewsViewGtag();

    return (
        <ProductPageProvider>
            <ProductReviewPageProvider>
                <ProductReviewPage breadcrumbs={pageProps.breadcrumbs} />
            </ProductReviewPageProvider>
        </ProductPageProvider>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const {breadcrumbs} = await productReviewsControllerByCode(store, ctx);

    return {
        props: {breadcrumbs},
    };
});

export default ProductReview;
